import { Component, OnInit, Input, Output, SimpleChanges } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormGroup, FormControl } from '@angular/forms';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-awards-home',
  templateUrl: './awards-home.component.html',
  styleUrls: ['./awards-home.component.scss']
})
export class AwardsHomeComponent implements OnInit {

  awards: any;
  @Input() month = null;
  download = false;
  download2 = false;

  u = Utils;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getAwards();

  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    //console.log('changes',changes);
    this.getAwards();
  }

  getAwards(){

    if(this.month){
      this.okService.get("awards",{month:this.month})
      .subscribe((data) => {
  
        this.awards = data.body;
        //console.log(this.awards);
  
      });
    }

  }

  downloadCertificates(){

    this.download = true;

    this.okService.download2("awards/certificatespdf",{month:this.month}).subscribe((data) => {

      this.download = false;

    });
  }

  exportAwardStats(){

    this.download2 = true;

    this.okService.download2("awards/exportscores",{month:this.month}).subscribe((data) => {

      this.download2 = false;

    });
  }


}
